import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export function PasswordInput({ className = "", "data-testid": testId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} data-testid={testId} type={show ? "text" : "password"} className={`pr-10 ${className}`} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Sembunyikan sandi" : "Lihat sandi"}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-emerald-700 transition-colors"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
